// Generated by ReScript, PLEASE EDIT WITH CARE

import * as SurgeStateMapper from "../../mapper/SurgeStateMapper.bs.js";
import * as SurgeErrorConverter from "./SurgeErrorConverter.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";

function execute(data) {
  return SurgeStateMapper.Campaigns.builder(data);
}

var SurgeCampaignRepoConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var SurgeCampaignResponseConverter = partial_arg(SurgeCampaignRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function execute$1(data) {
  return SurgeStateMapper.GeoRegions.builder(data);
}

var SurgeGeoRegionRepoConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var SurgeGeoRegionResponseConverter = partial_arg$1(SurgeGeoRegionRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function execute$2(data) {
  return SurgeStateMapper.VehicleTypes.builder(data);
}

var SurgeVehicleTypesRepoConfig = {
  execute: execute$2
};

var partial_arg$2 = ResponseHandler$Catalyst.ResponseConverter;

var SurgeVehicleTypesResponseConverter = partial_arg$2(SurgeVehicleTypesRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function execute$3(data) {
  return SurgeStateMapper.Zones.builder(data);
}

var SurgeZonesRepoConfig = {
  execute: execute$3
};

var partial_arg$3 = ResponseHandler$Catalyst.ResponseConverter;

var SurgeZonesResponseConverter = partial_arg$3(SurgeZonesRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function execute$4(data) {
  return SurgeStateMapper.CreateCampiagn.execute(data);
}

var SurgeCreateCampaignRepoConfig = {
  execute: execute$4
};

var partial_arg$4 = ResponseHandler$Catalyst.ResponseConverter;

var SurgeCreateCampaignResponseConverter = partial_arg$4(SurgeCreateCampaignRepoConfig, {
      execute: SurgeErrorConverter.execute
    });

function execute$5(data) {
  return SurgeStateMapper.DisableCampaign.execute(data);
}

var SurgeDeleteCampaignRepoConfig = {
  execute: execute$5
};

var partial_arg$5 = ResponseHandler$Catalyst.ResponseConverter;

var SurgeDeleteCampaignResponseConverter = partial_arg$5(SurgeDeleteCampaignRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  SurgeCampaignRepoConfig ,
  SurgeCampaignResponseConverter ,
  SurgeGeoRegionRepoConfig ,
  SurgeGeoRegionResponseConverter ,
  SurgeVehicleTypesRepoConfig ,
  SurgeVehicleTypesResponseConverter ,
  SurgeZonesRepoConfig ,
  SurgeZonesResponseConverter ,
  SurgeCreateCampaignRepoConfig ,
  SurgeCreateCampaignResponseConverter ,
  SurgeDeleteCampaignRepoConfig ,
  SurgeDeleteCampaignResponseConverter ,
  
}
/* SurgeCampaignResponseConverter Not a pure module */
